import { delay, put, takeEvery, call, select } from 'redux-saga/effects';
import { RequestWkblSpecialVideoListAction } from 'redux/actions/type';
import { REQUEST_WKBL_SPECIAL_VIDEO_LIST } from 'redux/actions/types';
import { getAPI } from 'commons/framework/KeyFlowAPIRequest';
import KeyFlowResponse from 'commons/framework/KeyFlowResponse';
import { API } from 'commons/constants/KeyFlowAPI';
import {
  requestWkblSpecialVideoListFailure,
  requestWkblSpecialVideoListSuccess,
  throwError,
} from 'redux/actions/actions';
import { PaginationType } from 'commons/framework/type';
import WkblVideoVO from 'commons/vo/WkblVideoVO';
import { AxiosResponse } from 'axios';

function* requestWkblSpecialVideoListSaga(action: RequestWkblSpecialVideoListAction) {
  try {
    const { param } = action.payload;
    let specialParam = param.getParam();

    if (specialParam.season === 'all') {
      const { season, ...rest } = specialParam;
      specialParam = rest;
    }

    const returnCount = specialParam.retr;
    const response: AxiosResponse = yield call(getAPI, API.WKBL_VIDEO_SEARCH, specialParam);
    const keyFlowResponse = new KeyFlowResponse(response.data);

    const resultList: WkblVideoVO[] = keyFlowResponse.getResult(WkblVideoVO) as WkblVideoVO[];
    const pagination: PaginationType = keyFlowResponse.page;

    yield put(
      requestWkblSpecialVideoListSuccess({ specialVideoList: resultList, pagination, returnCount }),
    );
  } catch (error: any | Error) {
    yield put(throwError({ error }));
    yield put(requestWkblSpecialVideoListFailure());
  }
}

export function* watchWkblSpecialVideoSaga() {
  yield takeEvery(REQUEST_WKBL_SPECIAL_VIDEO_LIST, requestWkblSpecialVideoListSaga);
}
